import { placeholderTypes } from "../../Types/Placeholder";
const placeholders = [
    {
        replacementKey: 'Resources', values: [],
        type: placeholderTypes.RESOURCES
    },
    {
        replacementKey: 'ActionReminders', values: [],
        type: placeholderTypes.ACTION_REMINDERS
    },
    {
        replacementKey: 'UnifiedClauses', values:
            [
                { id: 1, wfid: 32, isActive: true, field: '', display: 'Test Clause', },
                { id: 2, wfid: 33, isActive: true, field: '', display: 'Test Clause', },
                { id: 3, wfid: 30, isActive: true, field: '', display: 'Test Clause', },
                { id: 4, wfid: 31, isActive: true, field: '', display: 'Test Clause', },
            ],
        skipDefaultLoadingIfMissing: true,
        allowCustomReplyPeriods: true,
        allowConfigureReplyParty: true,
        type: placeholderTypes.UNIFIED_CLAUSES
    },
    {
        replacementKey: 'UnifiedReplyOptions', values:
            [
                { id: 1, wfid: 32, isActive: true, field: 'ACCEPT', display: 'Accepted', },
                { id: 2, wfid: 32, isActive: true, field: 'ACCEPT_WITH_COMMENTS', display: 'Accepted with comments', },
                { id: 3, wfid: 32, isActive: true, field: 'NOT_ACCEPTED', display: 'Not accepted', },
                { id: 4, wfid: 32, isActive: true, field: 'NOT_ACCEPTED_RESUBMIT', display: 'Not accepted - Resubmit', },
                { id: 5, wfid: 32, isActive: true, field: 'NO_REPLY_REQUIRED', display: 'Reply not required', },

                { id: 6, wfid: 33, isActive: true, field: 'ACCEPT', display: 'Accepted', },
                { id: 7, wfid: 33, isActive: true, field: 'ACCEPT_WITH_COMMENTS', display: 'Accepted with comments', },
                { id: 8, wfid: 33, isActive: true, field: 'NOT_ACCEPTED', display: 'Not accepted', },
                { id: 9, wfid: 33, isActive: true, field: 'NOT_ACCEPTED_RESUBMIT', display: 'Not accepted - Resubmit', },
                { id: 10, wfid: 33, isActive: true, field: 'NO_REPLY_REQUIRED', display: 'Reply not required', },
            ],
        skipDefaultLoadingIfMissing: true,
        possibleFields: ["ACCEPT", "ACCEPT_WITH_COMMENTS", "NOT_ACCEPTED", "NOT_ACCEPTED_RESUBMIT", "NO_REPLY_REQUIRED"],
        type: placeholderTypes.UNIFIED_REPLY_OPTIONS
    },
];
export default placeholders;